import { render, staticRenderFns } from "./QScoreCardResets.vue?vue&type=template&id=3bbddd7e&scoped=true&"
import script from "./QScoreCardResets.vue?vue&type=script&lang=js&"
export * from "./QScoreCardResets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbddd7e",
  null
  
)

export default component.exports